import React from 'react';
import { DataFormat } from '../utils/parsers';

export default function FormatSelector({
  format,
  onFormatChange,
  detectedFormat,
  csvHeaders,
  csvPrimaryKey,
  onCsvPrimaryKeyChange
}) {
  return (
    <div className="format-selector">
      <div className="format-controls">
        <label className="format-label">
          Format:
          <select
            value={format || 'auto'}
            onChange={(e) => onFormatChange(e.target.value === 'auto' ? null : e.target.value)}
            className="format-select"
          >
            <option value="auto">Auto-detect</option>
            <option value={DataFormat.JSON}>JSON</option>
            <option value={DataFormat.XML}>XML</option>
            <option value={DataFormat.CSV}>CSV</option>
          </select>
        </label>

        {detectedFormat && (
          <span className="detected-format">
            Detected: <strong>{detectedFormat.toUpperCase()}</strong>
          </span>
        )}

        {(format === DataFormat.CSV || detectedFormat === DataFormat.CSV) && csvHeaders.length > 0 && (
          <label className="format-label csv-key-selector">
            Primary Key:
            <select
              value={csvPrimaryKey || ''}
              onChange={(e) => onCsvPrimaryKeyChange(e.target.value)}
              className="format-select"
            >
              <option value="">None (array comparison)</option>
              {csvHeaders.map(header => (
                <option key={header} value={header}>{header}</option>
              ))}
            </select>
          </label>
        )}
      </div>
    </div>
  );
}
